var performanceTableData = {
  name: 'performanceTable',
  data: [{
    headerBgColor: '#f5f5f5',
    hoverBgColor: '#f5f5f5',
    hightLightBgColor: '#F0F3FF'
  }]
};
export default performanceTableData;